import './App.css';
import {MyButton} from "./AppUi"
import React from 'react';
import FrmKontakt from "./components/FrmKontakt";

class App extends React.Component {


  nakonfig = "";
  naucit = "";
  zohnat = "";
  formdata ={};
  alertok = "";
  alerterr = "";
  nadpis = "";
  mobil = "";
  mail = "";
  meno = "";
  dokonc = "";

  naplnTextyPodlaJazyka() {
    let jazyk = document.getElementById("lit-cs-lang4r").innerHTML;
    if (String(jazyk) == 'sk') {
      this.nakonfig = "nakonfigurovať";
      this.naucit = "naučiť + nakonfigurovať";
      this.zohnat = "zohnať";
      this.konf = "Konfigurácia zariadenia";
      this.skoleni = "Školenie k zariadeniu";
      this.prostred = "Sprostredkovanie zariadenia";

      this.formdata.alertok = "Správa bola odoslaná. Budeme Vás kontaktovať do 72 hodín.";
      this.formdata.alerterr = "Správu žiaľ nebolo možné odoslať. Kontaktujte nás prosím emailom alebo telefonicky.";
      this.formdata.nadpis = "Teší nás že máte záujem o naše služby. Nechajte nám prosím na vás kontakt, a hneď ako to bude možné, sa vám budeme venovať. Vopred ďakujeme. Ako vás máme kontaktovať?";
      this.formdata.mobil = "cez mobil";
      this.formdata.mail = "cez email";
      this.formdata.meno = "Meno";
      this.formdata.dokonc = "Dokončiť";

    } else if (String(jazyk) == 'cz') {
      this.nakonfig = "nakonfigurovat";
      this.naucit = "naučit + nakonfigurovat";
      this.zohnat = "sehnat";
      this.konf = "Konfigurace zařízení";
      this.skoleni = "Školení k zařízení";
      this.prostred = "Zprostředkování zařízení";

      this.formdata.alertok = "Zpráva byla odeslána. Budeme Vás kontaktovat do 72 hodin.";
      this.formdata.alerterr = "Zprávu bohužel nebylo možné odeslat. Kontaktujte nás prosím emailem nebo telefonicky.";
      this.formdata.nadpis = "Těší nás, že máte zájem o naše služby. Nechte nám prosím na vás kontakt, a jakmile to bude možné, se vám budeme věnovat. Předem děkujeme. Jak vás máme kontaktovat?";
      this.formdata.mobil = "přes mobil";
      this.formdata.mail = "přes email";
      this.formdata.meno = "Jméno";
      this.formdata.dokonc = "Dokončit";

    }
  }

  constructor(props) {
    super(props);
    this.naplnTextyPodlaJazyka();
  }

  render() { const tlacitkaAkcie = [
    { 
      nazov: this.nakonfig,
      poziadavka: this.konf,
      farba:"#ff0c55"
    },
    { 
      nazov: this.naucit,
      poziadavka: this.skoleni,
      farba:"#17cff4"
    },
    { 
      nazov: this.zohnat,
      poziadavka: this.prostred,
      farba:"#ffba00"
    }
  ];



  const vratForm = (poziadavka) => {
    console.log ("[LCK]: kliknutie na tlacitko [start]");

    const hdnPoziadavka = document.getElementById('hdnPoziadavka');
    hdnPoziadavka.value = poziadavka;
    
    const titulok = document.getElementById('lit-frm-mod-tit');
    titulok.innerHTML = poziadavka;
    
    
    console.log ("[LCK]: kliknutie na tlacitko [end]");
  }

   return (
    <div className="lit-cmp-kontakt-wrapper">
      {tlacitkaAkcie.map( 
        tlacitko => <div>
                      <MyButton type="button" data-bs-toggle="modal" data-bs-target="#exampleModal" inputColor={tlacitko.farba} onClick={() => vratForm(tlacitko.poziadavka)}>{tlacitko.nazov}</MyButton>
                    </div>
      )
      }
      <FrmKontakt formdata={this.formdata} ></FrmKontakt>
    </div>
  );
    }

}

export default App;
